import ConfirmationDialog from 'components/ReusableComponents/ConfirmationDialog'
import { useEffect, useState } from 'react'
import pmsApi from 'services/api/pms'

import styles from './EmailLogsDialog.module.scss'

function EmailLogsDialog({ onClose, onBack, email }) {
  const [data, setData] = useState([])

  useEffect(() => {
    pmsApi.getHistoriesByEmail({ email }).then(res => {
      setData(res)
    })
  }, [email])

  console.log({ data })

  return (
    <ConfirmationDialog
      hasDangerousAction
      hasCloseButton
      // hasConfirmButton={false}
      title={`6 Records recieved`}
      onClose={onClose}
      onBack={onBack}
      contentPadding="0"
    >
      <div className={styles.row}>
        <div className={styles.statusCol}>
          <p className={styles.title}>Last Record</p>
          <p className={styles.subTitle}>asd</p>
        </div>

        <div className={styles.statusCol}>
          <p className={styles.title}>Records</p>
          <p className={styles.subTitle}>6</p>
        </div>

        <div className={styles.buttonCol}>See all records</div>
      </div>
    </ConfirmationDialog>
  )
}

export default EmailLogsDialog
